<template>
  <v-dialog v-model="dialog" width="500">
    <v-card>
      <gg-toolbar @close="close">
        Delete SSH key
      </gg-toolbar>

      <v-card-text>
        <p>Are you certain that you wish to delete the key named “{{ sshKey.name }}”?</p>
      </v-card-text>
      <v-card-actions class="justify-content-end">
        <gg-btn class="mb-0" @click="close" secondary>Cancel</gg-btn>
        <gg-btn
          :loading="loading"
          class="mb-0"
          @click="deleteSshKey"
        >
          Delete
        </gg-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import modalMixin from '@/mixins/modal'

export default {
  name: 'DeleteSShKeyModal',
  mixins: [modalMixin],
  props: {
    sshKey: {
      type: Object,
      required: true
    },
    pub: {
      type: [String, Number],
      required: true
    },
  },
  data () {
    return {
      loading: false,
    }
  },
  methods: {
    ...mapActions(['deleteHostingSshKey', 'reportError', 'reportSuccess']),
    deleteSshKey () {
      this.loading = true
      this.deleteHostingSshKey({
        pub: this.pub,
        name: this.sshKey.name,
        _username: this.$route.query.user,
      }).then(
        data => {
          const location = data[0].keyfile || ''
          this.reportSuccess(`The key with the name “${name}” which was located at “${location}” has been removed.`)
          this.$emit('key-deleted')
          this.close()
        },
        error => {
          this.reportError(error)
          this.loading = false
          this.close()
        }
      )
    },
  },
}
</script>
